module.exports = __webpack_public_path__ + "static/media/norton-think-about-nothing-album-cover.5a35a246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/music/norton-think-about-nothing/norton-think-about-nothing-album-cover.jpg
// module id = 20
// module chunks = 0